import type { ItemGridToolbarProps } from "../ItemGridToolbar/ItemGridToolbar";
import { ItemGridToolbar } from "../ItemGridToolbar/ItemGridToolbar";
import { ItemGrid, type ItemGridProps } from "./ItemGrid";

export type ItemGridWithToolbarProps = {
  propsItemGrid: ItemGridProps;
  propsItemGridToolbar: ItemGridToolbarProps;
};

export function ItemGridWithToolbar({
  propsItemGrid,
  propsItemGridToolbar,
}: ItemGridWithToolbarProps) {
  return (
    <>
      <ItemGridToolbar {...propsItemGridToolbar} />
      <div className="mt-4">
        <ItemGrid {...propsItemGrid} />
      </div>
    </>
  );
}
